"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class QueryGatewayApi extends runtime.BaseAPI {
    /**
     * CreateConnection
     * CreateConnection
     */
    queryGatewayServiceCreateConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceCreateConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.CreateConnectionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1CreateConnectionRequestToJSON(requestParameters.tableauQuerygatewayV1CreateConnectionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1CreateConnectionResponseFromJSON(jsonValue));
        });
    }
    /**
     * CreateConnection
     * CreateConnection
     */
    queryGatewayServiceCreateConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceCreateConnectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * CreateQueryOperationWithSession
     * CreateQueryOperationWithSession
     */
    queryGatewayServiceCreateQueryOperationWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceCreateQueryOperationWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.CreateQueryOperationWithSessionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/query-operations`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1CreateQueryOperationWithSessionRequestToJSON(requestParameters.tableauQuerygatewayV1CreateQueryOperationWithSessionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GoogleLongrunningOperationFromJSON(jsonValue));
        });
    }
    /**
     * CreateQueryOperationWithSession
     * CreateQueryOperationWithSession
     */
    queryGatewayServiceCreateQueryOperationWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceCreateQueryOperationWithSessionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * CreateSession
     * CreateSession
     */
    queryGatewayServiceCreateSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.CreateSessionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1CreateSessionRequestToJSON(requestParameters.tableauQuerygatewayV1CreateSessionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1CreateSessionResponseFromJSON(jsonValue));
        });
    }
    /**
     * CreateSession
     * CreateSession
     */
    queryGatewayServiceCreateSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceCreateSessionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * DeleteConnection
     * DeleteConnection
     */
    queryGatewayServiceDeleteConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceDeleteConnection.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceDeleteConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * DeleteConnection
     * DeleteConnection
     */
    queryGatewayServiceDeleteConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.queryGatewayServiceDeleteConnectionRaw(requestParameters);
        });
    }
    /**
     * DeleteQueryOperation
     * DeleteQueryOperationWithSession
     */
    queryGatewayServiceDeleteQueryOperationWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling queryGatewayServiceDeleteQueryOperationWithSession.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceDeleteQueryOperationWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/query-operations/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * DeleteQueryOperation
     * DeleteQueryOperationWithSession
     */
    queryGatewayServiceDeleteQueryOperationWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.queryGatewayServiceDeleteQueryOperationWithSessionRaw(requestParameters);
        });
    }
    /**
     * DeleteSession
     * DeleteSession
     */
    queryGatewayServiceDeleteSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceDeleteSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * DeleteSession
     * DeleteSession
     */
    queryGatewayServiceDeleteSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.queryGatewayServiceDeleteSessionRaw(requestParameters);
        });
    }
    /**
     * DescribeColumnsWithSession
     * DescribeColumnsWithSession
     */
    queryGatewayServiceDescribeColumnsWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceDescribeColumnsWithSession.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceDescribeColumnsWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.DescribeColumnsWithSessionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}/columns:describe`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1DescribeColumnsWithSessionRequestToJSON(requestParameters.tableauQuerygatewayV1DescribeColumnsWithSessionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1DescribeColumnsWithSessionResponseFromJSON(jsonValue));
        });
    }
    /**
     * DescribeColumnsWithSession
     * DescribeColumnsWithSession
     */
    queryGatewayServiceDescribeColumnsWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceDescribeColumnsWithSessionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * GenerateConnectionDetails
     * GenerateConnectionDetailsWithSession
     */
    queryGatewayServiceGenerateConnectionDetailsWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGenerateConnectionDetailsWithSession.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceGenerateConnectionDetailsWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.GenerateConnectionDetailsWithSessionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}/details:generate`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1GenerateConnectionDetailsWithSessionRequestToJSON(requestParameters.tableauQuerygatewayV1GenerateConnectionDetailsWithSessionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GenerateConnectionDetailsWithSessionResponseFromJSON(jsonValue));
        });
    }
    /**
     * GenerateConnectionDetails
     * GenerateConnectionDetailsWithSession
     */
    queryGatewayServiceGenerateConnectionDetailsWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGenerateConnectionDetailsWithSessionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get connection settings for a particular type of connection
     * GetConnectionSettingsWithSession
     */
    queryGatewayServiceGetConnectionSettingsWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.dbClass === null || requestParameters.dbClass === undefined) {
                throw new runtime.RequiredError('dbClass', 'Required parameter requestParameters.dbClass was null or undefined when calling queryGatewayServiceGetConnectionSettingsWithSession.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetConnectionSettingsWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connection-info/{db_class}/settings`.replace(`{${"db_class"}}`, encodeURIComponent(String(requestParameters.dbClass))).replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GetConnectionSettingsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get connection settings for a particular type of connection
     * GetConnectionSettingsWithSession
     */
    queryGatewayServiceGetConnectionSettingsWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetConnectionSettingsWithSessionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * GetDatabases
     * GetDatabases
     */
    queryGatewayServiceGetDatabasesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetDatabases.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceGetDatabases.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.GetDatabasesRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}/databases`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1GetDatabasesRequestToJSON(requestParameters.tableauQuerygatewayV1GetDatabasesRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GetDatabasesResponseFromJSON(jsonValue));
        });
    }
    /**
     * GetDatabases
     * GetDatabases
     */
    queryGatewayServiceGetDatabases(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetDatabasesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get connection settings for a particular type of connection
     * GetModularConnectionSettings
     */
    queryGatewayServiceGetModularConnectionSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.dbClass === null || requestParameters.dbClass === undefined) {
                throw new runtime.RequiredError('dbClass', 'Required parameter requestParameters.dbClass was null or undefined when calling queryGatewayServiceGetModularConnectionSettings.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetModularConnectionSettings.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connection-info/{db_class}/modular-settings`.replace(`{${"db_class"}}`, encodeURIComponent(String(requestParameters.dbClass))).replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GetModularConnectionSettingsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get connection settings for a particular type of connection
     * GetModularConnectionSettings
     */
    queryGatewayServiceGetModularConnectionSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetModularConnectionSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get connection attributes via keychain
     * GetOAuthKeychainAttributes
     */
    queryGatewayServiceGetOAuthKeychainAttributesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetOAuthKeychainAttributes.');
            }
            if (requestParameters.keychainId === null || requestParameters.keychainId === undefined) {
                throw new runtime.RequiredError('keychainId', 'Required parameter requestParameters.keychainId was null or undefined when calling queryGatewayServiceGetOAuthKeychainAttributes.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/oauth/get-oauth-attributes/{keychain_id}`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"keychain_id"}}`, encodeURIComponent(String(requestParameters.keychainId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GetOAuthKeychainAttributesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get connection attributes via keychain
     * GetOAuthKeychainAttributes
     */
    queryGatewayServiceGetOAuthKeychainAttributes(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetOAuthKeychainAttributesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * GetQueryOperation
     * GetQueryOperationWithSession
     */
    queryGatewayServiceGetQueryOperationWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling queryGatewayServiceGetQueryOperationWithSession.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetQueryOperationWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/query-operations/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GoogleLongrunningOperationFromJSON(jsonValue));
        });
    }
    /**
     * GetQueryOperation
     * GetQueryOperationWithSession
     */
    queryGatewayServiceGetQueryOperationWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetQueryOperationWithSessionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * GetResults
     * GetResultsWithSession
     */
    queryGatewayServiceGetResultsWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.pageToken === null || requestParameters.pageToken === undefined) {
                throw new runtime.RequiredError('pageToken', 'Required parameter requestParameters.pageToken was null or undefined when calling queryGatewayServiceGetResultsWithSession.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetResultsWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/query-operations/{page_token}/results`.replace(`{${"page_token"}}`, encodeURIComponent(String(requestParameters.pageToken))).replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GetResultsResponseFromJSON(jsonValue));
        });
    }
    /**
     * GetResults
     * GetResultsWithSession
     */
    queryGatewayServiceGetResultsWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetResultsWithSessionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * GetSchemas
     * GetSchemas
     */
    queryGatewayServiceGetSchemasRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetSchemas.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceGetSchemas.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.GetSchemasRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}/schemas`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1GetSchemasRequestToJSON(requestParameters.tableauQuerygatewayV1GetSchemasRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GetSchemasResponseFromJSON(jsonValue));
        });
    }
    /**
     * GetSchemas
     * GetSchemas
     */
    queryGatewayServiceGetSchemas(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetSchemasRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * GetTables
     * GetTables
     */
    queryGatewayServiceGetTablesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetTables.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceGetTables.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.GetTablesRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}/tables`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1GetTablesRequestToJSON(requestParameters.tableauQuerygatewayV1GetTablesRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GetTablesResponseFromJSON(jsonValue));
        });
    }
    /**
     * GetTables
     * GetTables
     */
    queryGatewayServiceGetTables(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetTablesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * GetWarehouses
     * GetWarehouses
     */
    queryGatewayServiceGetWarehousesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceGetWarehouses.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceGetWarehouses.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.GetWarehousesRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}/warehouses`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1GetWarehousesRequestToJSON(requestParameters.tableauQuerygatewayV1GetWarehousesRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1GetWarehousesResponseFromJSON(jsonValue));
        });
    }
    /**
     * GetWarehouses
     * GetWarehouses
     */
    queryGatewayServiceGetWarehouses(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceGetWarehousesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List supported connection types
     * ListSupportedConnectionTypes
     */
    queryGatewayServiceListSupportedConnectionTypesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceListSupportedConnectionTypes.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connection-info/supported-connection-types`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1ListSupportedConnectionTypesResponseFromJSON(jsonValue));
        });
    }
    /**
     * List supported connection types
     * ListSupportedConnectionTypes
     */
    queryGatewayServiceListSupportedConnectionTypes(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceListSupportedConnectionTypesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * SearchDatabasesWithSession
     * SearchDatabasesWithSession
     */
    queryGatewayServiceSearchDatabasesWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceSearchDatabasesWithSession.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceSearchDatabasesWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.SearchDatabasesWithSessionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}/databases:search`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1SearchDatabasesWithSessionRequestToJSON(requestParameters.tableauQuerygatewayV1SearchDatabasesWithSessionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1SearchDatabasesResponseFromJSON(jsonValue));
        });
    }
    /**
     * SearchDatabasesWithSession
     * SearchDatabasesWithSession
     */
    queryGatewayServiceSearchDatabasesWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceSearchDatabasesWithSessionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * SearchTablesWithSessions
     * SearchTablesWithSessions
     */
    queryGatewayServiceSearchTablesWithSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling queryGatewayServiceSearchTablesWithSession.');
            }
            if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
                throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling queryGatewayServiceSearchTablesWithSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querygateway.v1.SearchTablesWithSessionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-gateway-service/sessions/{session_id}/connections/{connection_id}/tables:search`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerygatewayV1SearchTablesWithSessionRequestToJSON(requestParameters.tableauQuerygatewayV1SearchTablesWithSessionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerygatewayV1SearchTablesResponseFromJSON(jsonValue));
        });
    }
    /**
     * SearchTablesWithSessions
     * SearchTablesWithSessions
     */
    queryGatewayServiceSearchTablesWithSession(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryGatewayServiceSearchTablesWithSessionRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.QueryGatewayApi = QueryGatewayApi;
